import { Exception, NoResult } from '../../utilities/index.js';
import { LoggerLocationFormatter } from '../logging/index.js';
export class Dispatcher {
    static $type = 'dispatcher';
    static _eventMethodName = 'handleEvent';
    static _commandMethodName = 'handleCommand';
    static _queryMethodName = 'handleQuery';
    _eventHandlers = {};
    _commandHandlers = {};
    _queryHandlers = {};
    registerEventHandler(eventType, eventHandler) {
        let handlers = this._eventHandlers[eventType];
        if (!handlers) {
            handlers = [];
        }
        handlers.push(eventHandler);
        this._eventHandlers[eventType] = handlers;
        return this;
    }
    async handleEvent(event, execContext) {
        const handlers = this._eventHandlers[event.$type];
        if (handlers) {
            for (let i = 0; i < handlers.length; i += 1) {
                try {
                    const handler = handlers[i];
                    if (handler) {
                        await handler.handle(event, execContext);
                    }
                }
                catch (e) {
                    execContext.logger.error({
                        location: LoggerLocationFormatter.error(Dispatcher.$type, Dispatcher._eventMethodName),
                        error: e,
                    });
                }
            }
        }
        else {
            execContext.logger.info({
                location: LoggerLocationFormatter.end(Dispatcher.$type, Dispatcher._eventMethodName),
                message: `no handler found for event type: ${event.$type}`,
            });
        }
        return NoResult.instance;
    }
    registerCommandHandler(commandType, commandHandler) {
        this._commandHandlers[commandType] = commandHandler;
        return this;
    }
    async handleCommand(command, execContext) {
        const handler = this._commandHandlers[command.$type];
        if (handler) {
            const handlingResult = await handler.handle(command, execContext);
            return handlingResult;
        }
        execContext.logger.info({
            location: LoggerLocationFormatter.end(Dispatcher.$type, Dispatcher._commandMethodName),
            message: `no handler found for command type: ${command.$type}`,
        });
        throw new Exception('no-cmd-handler-registered');
    }
    registerQueryHandler(queryType, queryHandler) {
        this._queryHandlers[queryType] = queryHandler;
        return this;
    }
    async handleQuery(query, execContext) {
        const handler = this._queryHandlers[query.$type];
        if (handler) {
            const handlingResult = await handler.handle(query, execContext);
            return handlingResult;
        }
        execContext.logger.info({
            location: LoggerLocationFormatter.end(Dispatcher.$type, Dispatcher._queryMethodName),
            message: `no handler found for query type: ${query.$type}`,
        });
        throw new Exception('no-query-handler-registered');
    }
}
//# sourceMappingURL=dispatcher.js.map